module.exports = __webpack_public_path__ + "img/life-insurance.494bac5.svg";